/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div class="container">
    <div class="top">
      <div class="header">
        <img data-v-087656f9="" src="/static/img/logo.svg" alt="logo" class="logo">
        <span data-v-087656f9="" class="title">临电3D监控大屏</span>
      </div>
      <div class="desc">
        助力施工现场塔机安全管理
      </div>
    </div>
    <div class="main">
      <el-form key='1' :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="username">
          <el-input type="text" prefix-icon="el-icon-user" v-model.trim="ruleForm.username" auto-complete="off" placeholder="账号" @keyup.13.native='handleSubmit'></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" prefix-icon="el-icon-lock" v-model.trim="ruleForm.password" auto-complete="off" placeholder="密码" @keyup.13.native='handleSubmit'></el-input>
        </el-form-item>
        <el-checkbox v-model="checked" class="remember">记住密码</el-checkbox>
        <el-form-item style="width:100%;">
          <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit" :loading="logining">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <div class="copyright">
        Copyright © 2020 北京萨达智能技术有限公司
      </div>
    </div>
  </div>
</template>

<script>

import { login } from '@/api/metric'
export default {
  name: 'LoginPage',
  data () {
    return {
      logining: false,
      ruleForm: {
        username: '',
        password: ''
      },
      checked: false,
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    handleSubmit () {
      this.logining = true
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.checked) {
            localStorage.setItem('loginParams', JSON.stringify(this.ruleForm))
          } else {
            localStorage.removeItem('loginParams')
          }
          login(this.ruleForm).then((res) => {
            const {code, result, message} = res
            if (code === 200) {
              if (!result.account.belongProject) {
                this.$notify({
                  title: '提示',
                  message: '该账号没有所属项目,请联系管理员！',
                  type: 'warning'
                })
              } else {
                sessionStorage.setItem('auth', result.token)
                sessionStorage.setItem('projectHashId', result.account.belongProject.hashId)
                this.$router.push('/home')
              }
            } else {
              this.$notify({
                title: '提示',
                message: message,
                type: 'error'
              })
            }
            this.logining = false
          }).catch(() => {
            this.$notify({
              title: '错误',
              message: '请求异常！',
              type: 'error'
            })
          })
        } else {
          this.logining = false
        }
      })
    }
  },
  mounted () {
    let loginParams = localStorage.getItem('loginParams')
    if (loginParams) {
      try {
        let result = JSON.parse(loginParams)
        const {username, password} = result
        if (!!username && !!password) {
          this.ruleForm.username = username
          this.ruleForm.password = password
          this.checked = true
        }
      } catch (error) {

      }
    }
  }
}
</script>

<style scoped lang="scss">
  .container{
    width: 100%;
    min-height: 100%;
    background: #f0f2f5 url(/static/img/login-bg.svg) no-repeat 50%;
    background-size: 100%;
    padding: 110px 0 144px;
    position: relative;
    .top{
      text-align: center;
      margin-bottom:40px;
      .header{
        height: 44px;
        line-height: 44px;
        .logo{
          height: 44px;
          vertical-align: top;
          margin-right: 16px;
          border-style: none;
        }
        .title{
          font-size: 33px;
          color: rgba(0,0,0,.85);
          font-family: Avenir,Helvetica Neue,Arial,Helvetica,sans-serif;
          font-weight: 600;
          position: relative;
          top: 2px;
        }
      }
      .desc{
        font-size: 14px;
        color: rgba(0,0,0,.45);
        margin-top: 12px;
      }
    }
    .main{
      min-width: 260px;
      width: 368px;
      margin: 0 auto;
      .remember{
        margin-bottom:20px;
      }
    }
    .footer{
      position: absolute;
      width: 100%;
      bottom: 0;
      padding: 0 16px;
      margin: 48px 0 24px;
      text-align: center;
      .copyright{
        color: rgba(0,0,0,.45);
        font-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/login.vue